import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_ENV: z.enum(['development', 'test', 'staging', 'production']).default('development'),

  VITE_GRAPHQL_URL: z
    .union([z.url(), z.string().startsWith('/')])
    .default(import.meta.env.DEV ? '/graphql' : 'https://gateway.elscms.com/graphql'),

  VITE_GRAPHQL_SUBSCRIPTIONS_URL: z
    .string()
    .startsWith('/')
    .optional(),

  VITE_SENTRY_DSN: z.string().optional(),

  VITE_OPENPANEL_CLIENT_ID: z.string().optional(),

  VITE_DISCO_URL: z.string().optional(),

  VITE_PASSWORD_MIN: z.coerce.number().int().min(8).default(8),
});

export const env = envSchema.parse(import.meta.env);
